import { render, staticRenderFns } from "./excel-preview.vue?vue&type=template&id=33598478&scoped=true"
import script from "./excel-preview.vue?vue&type=script&lang=js"
export * from "./excel-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33598478",
  null
  
)

export default component.exports